import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { merge } from 'rxjs';
import { WsClient } from '@shared/ws';
import { RedemptionFailedEventSchema, RedemptionPaidEventSchema } from './points.ws';

@Injectable({ providedIn: 'root' })
export class PointsEventsService {
  private readonly ws = inject(WsClient);
  private readonly destroyRef = inject(DestroyRef);

  readonly redemptionRevision = signal(0);

  constructor() {
    merge(
      this.ws.on('points.redemption.paid', RedemptionPaidEventSchema),
      this.ws.on('points.redemption.failed', RedemptionFailedEventSchema),
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.redemptionRevision.update(value => value + 1));
  }
}
